import SharedNavbar from '../../../components/feature/SharedNavbar';
import SharedFooter from '../../../components/feature/SharedFooter';
import FloatingCallButton from '../../../components/feature/FloatingCallButton';
import ServiceHero from '../components/ServiceHero';
import ServiceContent from '../components/ServiceContent';
import ServiceCTA from '../components/ServiceCTA';

export default function SwitchboardsPage() {
  const serviceData = {
    title: 'Switchboard Upgrades & Repairs',
    subtitle: 'Modern Electrical Distribution',
    description: 'Is your switchboard outdated or overloaded? We provide professional switchboard upgrades, repairs, and replacements to ensure your electrical system can safely handle modern power demands. All work includes safety switch installation and compliance certification.',
    heroImage: 'https://public.readdy.ai/ai/img_res/6de523ed90efb1dd71761d7d2a0143d0.jpg',
    features: [
      {
        icon: 'ri-dashboard-line',
        title: 'Complete Upgrades',
        description: 'Replace old fuse boxes with modern switchboards'
      },
      {
        icon: 'ri-shield-check-line',
        title: 'Safety Switches',
        description: 'RCD and safety switch installation'
      },
      {
        icon: 'ri-add-circle-line',
        title: 'Circuit Additions',
        description: 'Add circuits for increased capacity'
      },
      {
        icon: 'ri-file-list-3-line',
        title: 'Compliance Cert',
        description: 'Full certification and documentation'
      }
    ],
    benefits: [
      'Switchboard upgrades and replacements',
      'Safety switch (RCD) installation',
      'Circuit breaker upgrades',
      'Additional circuit installation',
      'Meter box relocation',
      'Switchboard repairs',
      'Compliance with AS/NZS 3000',
      'Increased electrical capacity'
    ],
    processSteps: [
      {
        number: '01',
        title: 'Inspection',
        description: 'Assess current switchboard and power needs'
      },
      {
        number: '02',
        title: 'Design',
        description: 'Plan new switchboard layout and capacity'
      },
      {
        number: '03',
        title: 'Installation',
        description: 'Professional upgrade with minimal downtime'
      },
      {
        number: '04',
        title: 'Certification',
        description: 'Complete testing and compliance documentation'
      }
    ]
  };

  return (
    <div className="min-h-screen bg-white">
      <SharedNavbar />
      <ServiceHero 
        title={serviceData.title}
        subtitle={serviceData.subtitle}
        description={serviceData.description}
        heroImage={serviceData.heroImage}
      />
      <ServiceContent 
        features={serviceData.features}
        benefits={serviceData.benefits}
        processSteps={serviceData.processSteps}
      />
      <ServiceCTA />
      <div className="pb-20 lg:pb-0">
        <SharedFooter />
      </div>
      <FloatingCallButton />
    </div>
  );
}